export default __webpack_public_path__ + "static/media/Haylo-logo-white.f3134552.png";